<template>
  <div id="app">
    <router-view
      v-wechat-title="$route.meta.title"
      v-if="isRouterAlive"
    ></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    };
  },
  beforeCreate() {
    let count = 0;
    let imgs = [
      //用require的方式添加图片地址，直接添加图片地址的话，在build打包之后会查找不到图片，因为打包之后的图片名称会有一个加密的字符串
      // "https://mydcdn.boshgame.com/resource/img20230211/1.png",
      // "https://mydcdn.boshgame.com/resource/img20230211/2.png",
      // "https://mydcdn.boshgame.com/resource/img20230211/3.png",
      // "https://mydcdn.boshgame.com/resource/img20230211/4.png",
      // "https://mydcdn.boshgame.com/resource/img20230211/5.png",
      // "https://mydcdn.boshgame.com/resource/img20230211/6.png",
      // "https://mydcdn.boshgame.com/resource/img20230211/7.png",
      // "https://mydcdn.boshgame.com/resource/img20230211/8.png",
      // "https://mydcdn.boshgame.com/resource/img20230211/9.png",
      // "https://mydcdn.boshgame.com/resource/img20230211/10.png",
      // "https://mydcdn.boshgame.com/resource/img20230211/11.png",
      // "https://mydcdn.boshgame.com/resource/img20230211/12.png",
      // "https://mydcdn.boshgame.com/resource/img20230211/prize_bg.png"
    ];
    for (let img of imgs) {
      let image = new Image();
      image.onload = () => {
        count++;
        //alert(count);
      };
      image.src = img;
    }
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue